/* Lucía de Miguel · capa «experimento» (claude/experimento).
   Solo comportamiento de presentación: no añade, quita ni cambia líneas del carrito.
   - Cuentas atrás ligadas a una fecha real de fin de promoción (data-vrs-countdown).
   - Progreso del descuento por volumen (2 = −10 %, 3 = −15 %, 4 = −25 %) leyendo el carrito (GET /cart.js). */
(() => {
  const pad = (n) => String(n).padStart(2, '0');

  /* ---------- Cuenta atrás ---------- */
  const countdowns = new Set();

  function renderCountdown(el) {
    const end = Date.parse(el.dataset.vrsCountdown);
    const root = el.closest('[data-vrs-countdown-root]') || el;
    if (Number.isNaN(end)) return false;
    let left = Math.floor((end - Date.now()) / 1000);
    if (left <= 0) {
      root.hidden = true;
      return false;
    }
    const d = Math.floor(left / 86400); left -= d * 86400;
    const h = Math.floor(left / 3600); left -= h * 3600;
    const m = Math.floor(left / 60);
    const s = left - m * 60;
    const parts = el.querySelectorAll('[data-unit]');
    if (parts.length) {
      parts.forEach((p) => {
        const v = { d, h, m, s }[p.dataset.unit];
        p.textContent = p.dataset.unit === 'd' ? String(v) : pad(v);
      });
      const dayBox = el.querySelector('[data-unit-box="d"]');
      if (dayBox) dayBox.hidden = d === 0;
    } else {
      el.textContent = (d ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
    }
    root.hidden = false;
    return true;
  }

  function scanCountdowns(scope = document) {
    scope.querySelectorAll('[data-vrs-countdown]').forEach((el) => {
      if (renderCountdown(el)) countdowns.add(el);
    });
  }

  setInterval(() => {
    countdowns.forEach((el) => {
      if (!el.isConnected || !renderCountdown(el)) countdowns.delete(el);
    });
  }, 1000);

  /* ---------- Descuento por volumen (pack) ---------- */
  let cartCount = null;
  let fetching = null;

  function paintPacks() {
    if (cartCount === null) return;
    document.querySelectorAll('[data-vrs-pack]').forEach((el) => {
      const goal = Number(el.dataset.vrsPack) || 4;
      const n = Math.min(cartCount, goal);
      el.style.setProperty('--vrs-pack-fill', String(n / goal));
      el.querySelectorAll('[data-pack-slot]').forEach((slot, i) => slot.classList.toggle('is-on', i < n));
      const done = cartCount >= goal;
      el.classList.toggle('is-done', done);
      const msg = el.querySelector('[data-pack-msg]');
      if (msg) {
        // Escalones «prendas:%» (p. ej. 2:10,3:15,4:25), los mismos que los descuentos de Shopify.
        const tiers = (el.dataset.tiers || goal + ':25')
          .split(',')
          .map((t) => t.split(':').map(Number))
          .sort((a, b) => a[0] - b[0]);
        const got = tiers.filter((t) => cartCount >= t[0]).pop();
        const next = tiers.find((t) => cartCount < t[0]);
        if (got && next) {
          msg.textContent = 'Tienes un ' + got[1] + ' % en tu carrito. Con 1 prenda más subes al ' + next[1] + ' %.';
        } else if (got) {
          msg.textContent = '¡Tienes el ' + got[1] + ' %, el máximo! Se aplica solo en el carrito.';
        } else if (cartCount === 0) {
          msg.textContent =
            'Llévate ' + tiers.map((t, i) => (i ? t[0] + ' un ' : t[0] + ' prendas y ahorra un ') + t[1] + ' %').join(', ').replace(/, ([^,]*)$/, ' y $1') + '. Se aplica solo en el carrito.';
        } else {
          const left = next[0] - cartCount;
          msg.textContent = 'Con ' + left + (left === 1 ? ' prenda' : ' prendas') + ' más consigues un ' + next[1] + ' %. Se aplica solo en el carrito.';
        }
      }
    });
  }

  function refreshCart() {
    if (!document.querySelector('[data-vrs-pack]')) return;
    if (fetching) return fetching;
    fetching = fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((c) => {
        if (c && typeof c.item_count === 'number') {
          cartCount = c.item_count;
          paintPacks();
        }
      })
      .catch(() => {})
      .finally(() => {
        fetching = null;
      });
    return fetching;
  }

  function initPacks() {
    const first = document.querySelector('[data-vrs-pack]');
    if (!first) return;
    // Valor inicial del servidor; después se sincroniza con el carrito real.
    if (cartCount === null && first.dataset.count) cartCount = Number(first.dataset.count) || 0;
    paintPacks();
    const bubble = document.getElementById('cart-bubble-text');
    if (bubble && !bubble.dataset.vrsObserved) {
      bubble.dataset.vrsObserved = '1';
      new MutationObserver(() => refreshCart()).observe(bubble, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }
    window.addEventListener('pageshow', (e) => {
      if (e.persisted) refreshCart();
    });
  }

  /* ---------- Revelado suave de secciones ---------- */
  function initReveal() {
    if (!window.matchMedia('(prefers-reduced-motion: no-preference)').matches) return;
    const items = document.querySelectorAll('[data-vrs-x-reveal]');
    if (!items.length || !('IntersectionObserver' in window)) return;
    // Horizon (≥990 px): el contenedor de scroll es .page-wrapper, no la ventana.
    const wrapper = document.querySelector('.page-wrapper');
    const root =
      wrapper && matchMedia('(min-width: 990px)').matches && getComputedStyle(wrapper).overflowY !== 'visible'
        ? wrapper
        : null;
    // Seguridad: nunca dejar contenido oculto si el observador no llega a dispararse.
    setTimeout(() => items.forEach((el) => el.classList.add('is-in')), 4000);
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((en) => {
          if (en.isIntersecting) {
            en.target.classList.add('is-in');
            io.unobserve(en.target);
          }
        });
      },
      { root, rootMargin: '0px 0px -8% 0px' }
    );
    items.forEach((el) => {
      el.classList.add('vrs-x-reveal');
      io.observe(el);
    });
  }

  /* ---------- Abrir un acordeón de la ficha por su título ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-vrs-open-accordion]');
    if (!btn) return;
    const scope = btn.closest('.product-information, main') || document;
    // Preferencia: el diálogo de guía de tallas que ya existe en la ficha (misma fuente de datos).
    const dialogBtn = scope.querySelector('.vrs-sgb__btn');
    if (dialogBtn) {
      dialogBtn.click();
      return;
    }
    const wanted = btn.dataset.vrsOpenAccordion.trim().toLowerCase();
    const target = [...scope.querySelectorAll('details')].find((d) => {
      const s = d.querySelector('summary');
      return s && s.textContent.trim().toLowerCase().startsWith(wanted);
    });
    if (!target) return;
    target.open = true;
    const sum = target.querySelector('summary');
    target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
    if (sum) sum.focus({ preventScroll: true });
  });

  /* ---------- Sugerencias de búsqueda que rotan (buscador visible) ---------- */
  function initSuggest() {
    const els = document.querySelectorAll('[data-vrs-x-suggest]');
    if (!els.length) return;
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    els.forEach((el) => {
      const words = el.dataset.vrsXSuggest.split('|').filter(Boolean);
      if (words.length < 2 || reduce) return;
      let i = 0;
      setInterval(() => {
        i = (i + 1) % words.length;
        if (el.tagName === 'INPUT') {
          if (!el.value && document.activeElement !== el) el.placeholder = 'Buscar ' + words[i] + '…';
        } else {
          el.textContent = words[i];
        }
      }, 2600);
    });
  }

  /* ---------- Ficha: aviso bajo el botón según la variante elegida ---------- */
  function paintBuyzone(variantId) {
    document.querySelectorAll('[data-vrs-bz-map]').forEach((script) => {
      let map;
      try {
        map = JSON.parse(script.textContent);
      } catch (e) {
        return;
      }
      const data = map[String(variantId)];
      if (!data) return;
      const box = script.parentElement;
      const stock = box.querySelector('[data-vrs-bz-stock]');
      if (stock) {
        stock.hidden = !(data.q > 0);
        const qty = stock.querySelector('[data-vrs-bz-qty]');
        if (qty) qty.textContent = data.q;
      }
      const final = box.querySelector('[data-vrs-bz-final]');
      if (final && data.f) final.textContent = data.f;
    });
  }

  function initBuyzone() {
    // Horizon resuelve la promesa del evento con la variante nueva (variant-picker.js).
    document.addEventListener('shopify:product:select', (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
      if (!event.promise) return;
      event.promise
        .then(({ detail }) => {
          if (!detail?.resource?.id) return;
          paintBuyzone(detail.resource.id);
          filterIrl(detail.resource);
        })
        .catch(() => {});
    });
  }

  /* ---------- Ficha: Lucía de Miguel in real life ---------- */
  // Vídeos con color en el alt («[Rojo] …»): solo se ven con ese color elegido.
  function filterIrl(variant) {
    document.querySelectorAll('[data-vrs-irl]').forEach((root) => {
      const index = Number(root.dataset.vrsIrlColorIndex);
      if (index < 0 || !Array.isArray(variant.options)) return;
      const color = String(variant.options[index] || '').trim().toLowerCase();
      let visible = 0;
      root.querySelectorAll('.vrs-x-irl__item').forEach((item) => {
        const tags = item.dataset.vrsIrlColors;
        const show = !tags || !color || tags.includes('|' + color + '|');
        item.hidden = !show;
        if (show) visible += 1;
        else item.querySelector('video')?.pause();
      });
      root.hidden = visible === 0;
      const track = root.querySelector('.vrs-x-irl__track');
      if (track) {
        track.scrollLeft = 0;
        irlArrows(track);
      }
    });
  }

  function irlArrows(track) {
    const root = track.closest('[data-vrs-irl]');
    if (!root) return;
    const max = track.scrollWidth - track.clientWidth - 2;
    root.querySelectorAll('[data-vrs-irl-dir]').forEach((btn) => {
      btn.disabled = btn.dataset.vrsIrlDir === '-1' ? track.scrollLeft <= 2 : track.scrollLeft >= max;
    });
  }

  function initIrl() {
    document.addEventListener('click', (event) => {
      const play = event.target.closest('[data-vrs-irl-play]');
      if (play) {
        const tpl = play.nextElementSibling;
        if (!(tpl instanceof HTMLTemplateElement)) return;
        const video = tpl.content.querySelector('video')?.cloneNode(true);
        if (!video) return;
        video.muted = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('aria-label', play.getAttribute('aria-label').replace('Reproducir', ''));
        play.replaceWith(video);
        tpl.remove();
        video.play().catch(() => {});
        video.focus({ preventScroll: true });
        return;
      }
      const arrow = event.target.closest('[data-vrs-irl-dir]');
      if (arrow) {
        const track = document.getElementById(arrow.getAttribute('aria-controls'));
        const item = track?.querySelector('.vrs-x-irl__item');
        if (!track || !item) return;
        track.scrollBy({ left: Number(arrow.dataset.vrsIrlDir) * (item.offsetWidth + 8), behavior: 'smooth' });
      }
    });

    // Un solo vídeo a la vez.
    document.addEventListener(
      'play',
      (event) => {
        const current = event.target;
        if (!(current instanceof HTMLVideoElement) || !current.closest('[data-vrs-irl]')) return;
        document.querySelectorAll('[data-vrs-irl] video').forEach((v) => {
          if (v !== current && !v.paused) v.pause();
        });
      },
      true
    );

    document.addEventListener(
      'scroll',
      (event) => {
        if (event.target instanceof Element && event.target.matches('.vrs-x-irl__track')) irlArrows(event.target);
      },
      { capture: true, passive: true }
    );
    document.querySelectorAll('.vrs-x-irl__track').forEach(irlArrows);
  }

  /* ---------- Talla: sin preselección ---------- */
  // Horizon marca la primera talla al abrir la ficha (o la ventana rápida). Aquí la talla se ve
  // sin marcar hasta que el cliente toca una; si intenta añadir antes, se le pide que la elija.
  // No cambia la variante ni el carrito: solo evita añadir una talla que nadie ha elegido.
  const SIZE_RE = /^(talla|tallas|size|größe|grösse|taille|tamaño|numero|número)\b/i;
  const sizeChosen = new Set();

  function sizeFieldsets(scope = document) {
    return [...scope.querySelectorAll('variant-picker fieldset')].filter((fs) => {
      const inputs = fs.querySelectorAll('input[type="radio"]');
      return inputs.length > 1 && SIZE_RE.test((inputs[0].dataset.optionName || '').trim());
    });
  }

  function paintSizes(scope = document) {
    sizeFieldsets(scope).forEach((fs) => {
      const key = fs.querySelector('input[type="radio"]').name;
      fs.dataset.vrsSizeKey = key;
      fs.classList.toggle('vrs-size-pending', !sizeChosen.has(key));
    });
  }

  function sizeScope(el) {
    return (
      el.closest('dialog, quick-add-dialog, .quick-add-modal') ||
      el.closest('product-information, .product-information') ||
      document.querySelector('product-information, .product-information') ||
      document
    );
  }

  function askSize(fs) {
    let msg = fs.querySelector('.vrs-size-msg');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'vrs-size-msg';
      msg.setAttribute('role', 'alert');
      msg.textContent = 'Elige tu talla para añadirla al carrito';
      fs.querySelector('legend')?.after(msg);
    }
    fs.classList.remove('vrs-size-ask');
    void fs.offsetWidth;
    fs.classList.add('vrs-size-ask');
    const top = fs.getBoundingClientRect().top;
    if (top < 80 || top > window.innerHeight - 160) fs.scrollIntoView({ block: 'center', behavior: 'smooth' });
    const first = fs.querySelector('input[type="radio"]:not([aria-disabled="true"])');
    first?.focus({ preventScroll: true });
  }

  function blockIfNoSize(event) {
    const btn = event.target instanceof Element && event.target.closest('.add-to-cart-button, [name="add"]');
    const form = event.type === 'submit' ? event.target : btn?.form || btn?.closest('form');
    if (!btn && !(event.type === 'submit' && form?.matches('form[action*="/cart/add"]'))) return;
    const pending = sizeFieldsets(sizeScope(btn || form)).find((fs) => fs.classList.contains('vrs-size-pending'));
    if (!pending) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    askSize(pending);
  }

  function initSizes() {
    paintSizes();
    // En window (captura) para ir antes que los on:click de Horizon, que escuchan en document.
    window.addEventListener(
      'click',
      (event) => {
        const input = event.target instanceof Element && event.target.closest('variant-picker fieldset label, variant-picker fieldset input');
        if (input) {
          const fs = input.closest('fieldset');
          if (fs?.dataset.vrsSizeKey) {
            sizeChosen.add(fs.dataset.vrsSizeKey);
            fs.classList.remove('vrs-size-pending', 'vrs-size-ask');
            fs.querySelector('.vrs-size-msg')?.remove();
          }
          return;
        }
        blockIfNoSize(event);
      },
      true
    );
    document.addEventListener(
      'change',
      (event) => {
        const fs = event.target instanceof Element && event.target.closest('fieldset[data-vrs-size-key]');
        if (!fs) return;
        sizeChosen.add(fs.dataset.vrsSizeKey);
        fs.classList.remove('vrs-size-pending', 'vrs-size-ask');
        fs.querySelector('.vrs-size-msg')?.remove();
      },
      true
    );
    window.addEventListener('submit', blockIfNoSize, true);
    // Horizon vuelve a pintar el selector al cambiar de color o al abrir la ventana rápida.
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        paintSizes();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    initSizes();
    initSuggest();
    scanCountdowns();
    initPacks();
    initReveal();
    initBuyzone();
    initIrl();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Editor de temas: volver a pintar al recargar una sección.
  document.addEventListener('shopify:section:load', (e) => {
    scanCountdowns(e.target);
    paintPacks();
    e.target.querySelectorAll('.vrs-x-irl__track').forEach(irlArrows);
  });
})();
